import {ReduxRouterStateEpics} from './epics';
import {validateOptions} from './utils';


export * from './utils';

/**
 * @param {ReduxRouterStateOptions} options
 * @constructor
 */
export function ReduxRouterState(options) {
  validateOptions(options);

  this.options = options;
  this.epics = new ReduxRouterStateEpics(options);
}

/**
 * @typedef {Object} ReduxRouterStateOptions
 * @property {String} idParam
 * @property {Array<String>} stateNames
 * @property {String} noDataMessage
 * @property {String} fallbackStateName
 * @property {ReduxItem} reduxItem
 * @property {Logger} logger
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-ui-router-utils/index.js